import {toggleMark} from "prosemirror-commands";
import {schema} from "../../config/schema";

export const toggleMarkUnderline = toggleMark(schema.marks.underline)
